/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 * Page SubscriberId Info Tab component
 *
 * @author Yakov Gushchin
 * @author Alexander Golshtein
 * @author Ilya Baranchikov
 * @version 1.25.1
 * @since 1.12.0
 */

import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { ELogBusinessEventName, ELogBusinessEventType, logBusinessEvent } from '@modules/logging';

import { SubscriberIdInfoStyled } from './styled/SubscriberIdInfoStyled';
import SubscriberIdInfoGeneral from './SubscriberIdInfoGeneral';
import SubscriberIdInfoPiggyBank from './SubscriberIdInfoPiggyBank';
import SubscriberIdInfoTariff from './SubscriberIdInfoTariff';

const SubscriberIdInfo = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            logBusinessEvent({
                eventName: ELogBusinessEventName.B2B_SUBSCRIBER_CARD,
                type: ELogBusinessEventType.common,
            }),
        );
    }, [dispatch]);

    return (
        <SubscriberIdInfoStyled>
            <SubscriberIdInfoGeneral />

            <div className="subscriber-id-info__separate" />
            <SubscriberIdInfoTariff />

            <SubscriberIdInfoPiggyBank />
        </SubscriberIdInfoStyled>
    );
};

export default SubscriberIdInfo;
